import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';
import { useIntl } from 'react-intl';
import getLineGraphOptions from 'utils/get-line-graph-options';
import { TemperatureProfileInformation } from 'views/bluviu-nutrition/features/calibrations/types/temperature-profile-information.type';

type ChartProps = {
  temperatureProfile: TemperatureProfileInformation[];
};

const ViewTemperatureChart: React.FC<ChartProps> = ({ temperatureProfile }) => {
  const intl = useIntl();
  const PAGE_NAME_ID = `bluViuNutrition.calibrations.editCalibration.temperatureLocation.temperatureProfile.chart`;

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={
        {
          legend: {
            enabled: false,
          },
          defs: {
            patterns: [
              {
                id: 'custom-pattern',
                path: {
                  d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
                  stroke: '#f0f0f0',
                  strokeWidth: 1,
                },
                opacity: 0.9,
              },
            ],
          },
          ...getLineGraphOptions({
            xAxisTitle: intl.formatMessage({ id: `${PAGE_NAME_ID}.week` }),
            yAxisTitle: intl.formatMessage({ id: `${PAGE_NAME_ID}.degrees` }),
            formatNumber: intl.formatNumber,
          }),
          series: [
            {
              type: 'area',
              name: '',
              lineColor: '#0BB14D',
              color: 'url(#custom-pattern)',
              data: temperatureProfile.map((row) => ({
                x: row.weekNumber,
                y: parseFloat(Number(row.averageTemperature).toFixed(2)),
                name: `${intl.formatMessage({ id: `${PAGE_NAME_ID}.week` })} ${row?.weekNumber}`,
              })),
              tooltip: {
                valueSuffix: ' °C',
              },
            },
          ] as Highcharts.SeriesOptionsType[],
        } as Highcharts.Options
      }
    />
  );
};

export default React.memo(ViewTemperatureChart);
